import {Bank} from 'domain/usecases/private/refund/request/get-beneficiary-bank-data';
import {makeRefundPostBank} from 'main/factories/usecases';

export async function postRefundBankData(bankData: Bank) {
	const payload = {
		account: bankData.account,
		accountDigit: bankData.accountDigit,
		agency: bankData.agency,
		bank: bankData.bank.code,
		agencyDigit: bankData.agencyDigit,
	};

	await makeRefundPostBank().post(payload);

	return bankData;
}
